import { Images, SlidersHorizontal, Upload } from "lucide-react";

export function MobileNav({ onImport, onFilters }) {
  return (
    <nav className="mobile-nav" aria-label="移动端导航">
      <a href="#archive"><Images size={22} strokeWidth={1.4} /><span>照片</span></a>
      <button className="mobile-import" type="button" onClick={onImport} aria-label="导入照片"><Upload size={26} strokeWidth={1.4} /></button>
      <button type="button" onClick={onFilters}><SlidersHorizontal size={22} strokeWidth={1.4} /><span>筛选</span></button>
    </nav>
  );
}
